<template>
    <div class="panel">
        <div class="panel-body">
            <div class="row" style="padding-top: 10px">
                <div class="col-sm-3">
					<div class="panel panel-default" style="">
							<div class="panel-heading"><h4 class="panel-title"><i class="fa fa-tree" aria-hidden="true"></i>项目类型树形图</h4></div>
							<div class="panel-body" style="height: calc(100vh - 180px);width: 265px;overflow: auto;">
								 <ul id="jggx_tree" class="ztree" ></ul>
							</div>
					</div>
				</div>
                <div class="col-sm-9" style="padding-left: 0px;">
					<div style="padding-bottom: 10px;">
						<button class="btn btn-primary btn-sm" type="button" @click="addLx()"><i class="fa fa-plus" aria-hidden="true"></i>新增项目类型</button>
					</div>
					<div class="text-primary">
						<em>子类型列表：</em>
					</div>
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
                    />
                </div>
            </div>
        </div>
		<ZypxLxAdd ref="ZypxLxAdd"></ZypxLxAdd>
		<ZypxLxEdit ref="ZypxLxEdit"></ZypxLxEdit>
    </div>
</template>
<script>
    import $ from 'jquery';
    import tableMixin from '@/mixins/table.js';
    import ZypxLxAdd from './ZypxLxAdd.vue';
    import ZypxLxEdit from './ZypxLxEdit.vue';

    export default {
        mixins: [tableMixin],
        name:"ZypxLxList",
		components: {
			ZypxLxAdd,
			ZypxLxEdit
		},
        data:function(){
            return {
				flxName:'',
                query:{
					flxId:''
                },
                treeObj:null,
				selectedNode:null,
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
					{
                        field: 'mc',
                        title: '类型名称'
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            // let btnName=row.zt==1 ? '禁用' :'启用';
                            return this.vueFormatter({
                                template: '<div class="operation_column">' +
                                    '<a @click="edit(row)">修改</a> | ' +
                                    // '<button class="btn btn-xs btn-warning" @click="qtit(row)">'+btnName+'</button>&nbsp;&nbsp;' +
                                    '<a @click="del(row)">删除</a></div>',
                                data: { row },
                                methods: {
                                    edit: this.edit,
                                    del: this.del
                                }
                            })
                        }
                    }
                ],
                setting:{
                 	callback: {
                 		onClick: this.zTreeOnClick
                 	}
                }
            }
        },
        mounted(){
			this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
            this.load();
            this.loadTree();
        },
		beforeRouteUpdate(to, from, next){
			this.query = Object.assign(this.query,{current:1,size:10},to.query);
			this.load();
			next();
		},
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'基础数据'},{name:'职业培训'},{name:'项目类型管理'}]);
        },
        methods:{
			zTreeOnClick:function(event, treeId, treeNode){
				this.query.flxId = treeNode.id;
				this.flxName = treeNode.name;
				this.selectedNode = (this.treeObj.getSelectedNodes())[0];
				//刷新列表
				this.load(1,10);
			},
            loadTree:function(){
                this.$http.post("/htgl/inf/zypx/lx/tree",this.query).then(res=>{
                    let data = res.data;
                    if(data){
						this.treeObj = $.fn.zTree.init($("#jggx_tree"), this.setting, data);
						if(this.selectedNode){
							this.treeObj.selectNode(this.selectedNode);
						}
                    }
                })
            },
            //根据查询条件进行检索
            search:function(){
				 //将数据表格的页码以及每一页展示的数据重置为1，10
				 let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
				 this.$router.push({name:this.$route.name,query:query});
				this.loadTree();
            },
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/inf/zypx/lx/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            addLx:function(){
				this.$refs.ZypxLxAdd.open({flxName:this.flxName,
							flxId:this.query.flxId});
            },
            edit:function(row){
				this.$refs.ZypxLxEdit.open({id:row.id,
                            flxName:this.flxName,
                            flxId:this.query.flxId});
            },
            del:function(row){
				this.$confirm('确定执行此操作吗',()=>{
					this.$http.post("/htgl/inf/zypx/lx/sc",{id:row.id}).then((res)=>{
					    if(res.data==true){
							this.$success('操作成功',()=>{
								this.search();//刷新列表
							})
					    }
					});
				});
            },
		   pageChange:function(pageNumber, pageSize){
			let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
			this.$router.push({name:this.$route.name,query:query});
		   }
        }

    }
</script>